<template>
	<div class="container">
		<p class="indent">       拥有杂质谱分析数据库，全面的文献检索系统，核心技术团队同时拥有药物合成及药物分析两大技术平台，熟知药物申报相关的法律法规，致力于为全球制药企业提供客观、专业、高效的实验室研发和分析技术支持，业务涵盖基因毒性杂质研究、有关物质检测、残留溶剂检测、分析测试服务等，提供高质量、高效率、完整的解决方案。</p>
		<p class="indent">        我们将以专业的技术团队、丰富的项目经验以及先进的分析仪器设备，加快推进合作项目的进展，确保项目的每个阶段都能得到严格的质量保证。</p>
	</div>
</template>

<script>
	export default {
		data() {
			return {

			}
		},
		mounted() {},
		methods: {

		}
	}
</script>

<style lang="scss" scoped>
	.container {
		width: 900px;
		display: flex;
		flex-direction: column;

		.image1 {
			width: 900px;
			height: 500px;
		}

		.title {
			font-size: 30px;
			font-weight: bold;
			color: #333333;
			padding: 40px 0;
		}
		.indent{
			text-indent: 2em;
		}
		p{
			font-size: 16px;
			color: #333333;
			margin-bottom: 30px;
		}
		.text{
			font-size: 18px;
			font-weight: bold;
			color: #004098;
			margin-bottom: 10px;
		}
		.census {
			width: 100%;
			height: 300px;
			position: relative;
			margin-bottom: 20px;
			.el-image {
				width: 100%;
				height: 300px;
			}
		
			.range {
				width: 100%;
				height: 300px;
				position: absolute;
				top: 0;
				left: 0;
				background-color: rgba($color: #004098, $alpha: 0.8);
				display: flex;
				align-items: center;
				flex-wrap: wrap;
				justify-content: space-between;
				
				.li {
					width: 25%;
					height: 150px;
					font-size: 16px;
					color: #fff;
					display: flex;
					align-items: center;
					justify-content: center;
					flex-direction: column;
				
					.el-image {
						width: 50px;
						height: 50px;
						margin-bottom: 10px;
					}
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/service/pharmacy.vue